import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/folder',
  },
  {
    path: '/folder',
    component: () => import('@/app/views/folder/ListFolder.vue'),
  },
  {
    path: '/folder/new/:uuid?',
    component: () => import('@/app/views/folder/NewFolder.vue'),
  },
  // Catches stale links from the old /tabs/* layout — bookmarked URLs,
  // already-installed PWA shortcuts whose manifest start_url was recorded
  // at install time, or anything else pointing at a route that no longer
  // exists — instead of rendering a blank page.
  {
    path: '/:pathMatch(.*)*',
    redirect: '/folder',
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

export default router;
